module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-chapter element-with-heading full-character-formatting element-with-heading-image",
    attrs: {
      "id": "unnumbered-1"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-with-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title case-mixed"
  }, [_vm._v("Blurb")])])]), _vm._v(" "), _c('div', {
    staticClass: "heading-image-block heading-image-aspect-square heading-image-block-after-title-and-subtitle"
  }, [_c('div', {
    staticClass: "heading-image-size-container heading-image-width-250"
  }, [_c('img', {
    staticClass: "heading-image-image",
    attrs: {
      "alt": "",
      "src": "images/image-5_c2tldgnoihr5cgv3cml0zxi.jpg"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "unnumbered-1-text"
    }
  }, [_c('div', {
    staticClass: "alignment-block alignment-block-align-left"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("The dragon's blood that saved her had one little unforeseen consequence—it turned her into a "), _c('i', [_vm._v("draugr")]), _vm._v(", a vampire.")])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("Leslie always wanted to be number one at something, and the Readers’ Cruise was her chance to make a big splash into the romance writing world.")])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("Until she fell into the Atlantic Ocean.")])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("With her life hanging in the balance, it would take a miracle to save her from death’s icy grip.")])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("That miracle is Alistair McLeod, a handsome dragon-shifter, who shouldn’t exist. But now she's counted among the living dead.")])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("Marked and hungry, Leslie awakens as an unwilling vampire and a new member to the Order—the supernatural security force for a secret society of the shadow world.")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("Danger, intrigue, and murder are her new reality. And when women end up drained, their bodies mangled by a vampire’s bite, Leslie is the Order’s top suspect.")])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("These murders threaten everything the Order stands for, which means the Order now threatens her.")])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("To save her life, Leslie must now embrace her magical destiny—or fall victim to a deadly menace.")])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("Discover what’s at stake in Tina Glasneck’s new take on vampire lore with Once Bitten!")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c9c75d9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/blurb.vue
// module id = 69
// module chunks = 0